/**
 * Force a full browser navigation to a route.
 *
 * Using react-router's SPA push had a recurring bug in this app where after
 * a navigate() the URL would update but React's useLocation() did not
 * re-broadcast, so AppLayout kept rendering the previous page (URL shows
 * /ranking but you still see the home video grid). Switching to a full
 * browser navigation (window.location.href = path) wipes the React tree
 * and avoids the desync entirely.
 *
 * Cost: ~500ms extra per cross-page nav. Worth it for never having to
 * debug "I clicked Ranking but I'm still seeing videos" again.
 *
 * Use this anywhere you'd previously have used `navigate(path)` for a
 * cross-page transition. For purely modal/in-page state, plain useState
 * is fine.
 */
export const goFullReload = (path: string): void => {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === path) return;
  window.location.href = path;
};
